import { useParams } from "react-router-dom";
import { PublicStaticMap } from "@/components/public-static-map";
import { PublicProgressCard } from "@/components/public-progress-card";
import { ErrorState } from "@/components/error-state";
import { LoadingSpinner } from "@/components/ui/spinner";
import { useGetPublicStatus } from "@/api/orval";

export const PublicCity = () => {
  const { username, city } = useParams<{ username: string; city: string }>();

  const {
    data: profileData,
    isLoading: isProfileLoading,
    error: profileError,
  } = useGetPublicStatus(
    { username: username ?? "" },
    { query: { enabled: !!username, retry: false } },
  );

  if (isProfileLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="w-[200px]">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  if (profileError || !profileData?.is_public) {
    return (
      <ErrorState
        title="This profile isn't public"
        description={`@${username} hasn't made their profile public yet. Maybe they're still out running?`}
        fullScreen
      />
    );
  }

  return (
    <div className="relative h-screen w-full">
      <PublicStaticMap username={username} city={city} />
      <PublicProgressCard />
    </div>
  );
};
